module.exports = {
    fi: {
        phoneAbbr: "Puh.",
        emailSales: "myynti@youpret.com",
        emailHello: "hello@youpret.com",
        emailOffice: "office@youpret.com",
        emailOffice1: "laskutus@youpret.com",
        emailJobs: "jobs@youpret.com",
        addressTitle: "Youpret Oy",
        addressStreet: "Kauppakatu",
        addressNumber: "17 B",
        addressPostcode: "80100",
        addressCity: "Joensuu",
        addressCountry: "Suomi",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Heikki Vepsäläinen",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCEO: "Toimitusjohtaja",
        titleCEOInfo: "Myynti, sopimukset",
        emailDOS: "",
        emailDOSShort: "",
        nameDOS: "",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleDOS: "Myyntijohtaja",
        titleDOSInfo: "Yritysmyynti",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Heikki Vepsäläinen",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        titleCTO: "CTO",
        titleCTOInfo: "",
        nameSales: "Heikki Vepsäläinen",
        phoneSales: "+358401898688",
        phoneSalesCaption: "040 189 8688",
        emailSalesContact: "heikki.vepsalainen@youpret.com",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Jani Kämäräinen",
        emailJani: "jani.kamarainen@youpret.com",
        emailJaniShort: "jani@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        titleJani: "Tulkkauspalvelupäällikkö",
        titleJaniInfo: "",
        nameLaura: "Laura Kosonen",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        phoneLaura2: "+358400167960",
        phoneLauraCaption2: "+358 40 016 7960",
        titleLaura: "Asiantuntija, tulkkaus- ja henkilöstöpalvelut",
        titleLauraInfo: "",
        nameNea: "Nea Ruotsalainen",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "0406403600",
        phoneNeaCaption: "040 640 3600",
        titleNea: "Asiakaspalvelupäällikkö",
        titleNeaInfo: "",
        customerServiceNea: "(Asiakaspalvelu)",
        nameSuvi: "Suvi Kingelin",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        phoneSuvi: "+358400169278",
        phoneSuviCaption: "+358 400 169 278",
        customerServiceSwedish: "+358454908250",
        customerServiceSwedishCaption: "045 490 8250",
        titleSuvi: "Asiantuntija, asiakasneuvonta",
        titleSuviInfo: "",
        nameCOO: "Maya Rytkönen",
        emailMaya: "maya.rytkonen@youpret.com",
        emailMayaShort: "maya@youpret.com",
        MayaInfo: "(Vanhempainvapaalla)",
        phoneMaya: "+358400149295",
        phoneMayaCaption: "+358 400 149 295",
        titleMaya: "Operatiivinen johtaja",
        titleMayaInfo: "",
        nameAbrial: "Abrial Bertel",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        phoneAbrial: "+358456688113",
        phoneAbrialCaption: "",
        titleAbrial: "Kehityspäällikkö",
        titleAbrialInfo: "Raportointi",
        customerSupportCaption: "Tilaukset / asiakaspalvelu",
        customerService: "+358456688113",
        customerServiceCaption: "045 668 8113",
        customerServiceInSwedish: "Asiakaspalvelu ruotsiksi",
        nameSatu: "Satu Pirhonen",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneOlga: "+358406325979",
        phoneOlgaCaption: "+358 406 325 979",
        titleSatu: "Asiakkuuspäällikkö",
        titleSatuInfo: "",
        nameNeaK: "Nea Kolmonen",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "0400254410",
        phoneNeaKolmonenCaption: "0400 254 410",
        titleNeaKolmonen: "Markkinointi- ja viestintäpäällikkö",
        titleNeaKolmonenInfo: "",
        nameTanja: "Tanja Madzhugina",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 401 816 692",
        titleTanja: "Talous- ja hallintopäällikkö",
        titleTanjaInfo: "",
        nameAida: "Aida Jodeiri",
        titleAida:"Vastuullisuuskoordinaattori",
        
    },
    en: {
        phoneAbbr: "TEL ",
        emailSales: "sales@youpret.com",
        emailHello: "hello@youpret.com",
        emailOffice: "office@youpret.com",
        emailJobs: "jobs@youpret.com",
        addressTitle: "Youpret Oy",
        addressStreet: "Kauppakatu",
        addressNumber: "17 B",
        addressPostcode: "80100",
        addressCity: "Joensuu",
        addressCountry: "FINLAND",
        titleDOS: "Director of Sales",
        titleDOSInfo: "Sales",
        nameDOS: "",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleCEO: "CEO",
        titleCEOInfo: "",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Heikki Vepsäläinen",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCTO: "CTO",
        titleCTOInfo: "",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Heikki Vepsäläinen",
        nameCOO: "Maya Rytkönen",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        nameSales: "Heikki Vepsäläinen",
        phoneSales: "+358401898688",
        phoneSalesCaption: "+358 40 189 8688",
        emailSalesContact: "heikki.vepsalainen@youpret.com",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Jani Kämäräinen",
        titleJani: "Interpreter and client manager",
        titleJaniInfo: "",
        emailJani: "jani.kamarainen@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        nameNea: "Nea Ruotsalainen",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "+358406403600",
        phoneNeaCaption: "+358 40 640 3600",
        titleNea: "Customer service manager",
        titleNeaInfo: "",
        emailMaya: "maya.rytkonen@youpret.com",
        MayaInfo: "(On parental leave)",
        phoneMaya: "+358400149295",
        phoneMayaCaption: "+358 400 149 295",
        titleMaya: "COO",
        titleMayaInfo: "",
        nameAbrial: "Abrial Bertel",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        customerService: "+358456688113",
        customerServiceCaption: "+358 45 668 8113",
        titleAbrial: "Development manager",
        titleAbrialInfo: "Reporting",
        nameLaura: "Laura Kosonen",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        phoneLaura: "+358456688113",
        phoneLauraCaption: "+358 45 668 8113",
        titleLaura: "Expert, interpreter and staffing services",
        titleLauraInfo: "",
        nameSuvi: "Suvi Kingelin",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        phoneSuvi: "+358400169278",
        phoneSuviCaption: "+358 400 169 278",
        titleSuvi: "Customer Advisor",
        titleSuviInfo: "",
        customerSupportCaption: "Customer service",
        customerServiceInSwedish: "Customer service in Swedish",
        customerServiceSwedish: "+358454908250",
        customerServiceSwedishCaption: "+358 45 490 8250",
        nameSatu: "Satu Pirhonen",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneSatu: "+358406325979",
        phoneSatuCaption: "+358 406 325 979",
        titleSatu: "Account manager",
        titleSatuInfo: "",
        nameNeaK: "Nea Kolmonen",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "+358400254410",
        phoneNeaKolmonenCaption: "+358 40 025 4410",
        titleNeaKolmonen: "Marketing and communications manager",
        titleNeaKolmonenInfo: "",
        nameTanja: "Tanja Madzhugina",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 401 816 692",
        titleTanja: "Financial and administration manager",
        titleTanjaInfo: "",
        nameAida: "Aida Jodeiri",
        titleAida: "Sustainability Coordinator",
        phoneAccounting: "+358 40 014 9478",
        phoneAccountingCaption: "040 014 9478",
        phoneAccounting1: "040 014 9478",
    },
    ru: {
        phoneAbbr: "Puh.",
        emailSales: "myynti@youpret.com",
        emailHello: "hello@youpret.com",
        emailOffice: "office@youpret.com",
        emailJobs: "jobs@youpret.com",
        addressTitle: "Youpret Oy",
        addressStreet: "Kauppakatu",
        addressNumber: "17 B",
        addressPostcode: "80100",
        addressCity: "Joensuu",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Хейкки Вепсяляйнен",
        nameCEOFi: "(фин. Heikki Vepsäläinen)",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCEO: "Генеральный директор",
        titleCEOInfo: "Продажи, контракты",
        emailDOS: "",
        emailDOSShort: "",
        nameDOS: "",
        nameCOO: "Maya Rytkönen",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleDOS: "Myyntijohtaja",
        titleDOSInfo: "Продажи",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Хейкки Вепсяляйнен",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        titleCTO: "CTO",
        titleCTOInfo: "",
        nameSales: "Хейкки Вепсяляйнен",
        phoneSales: "+358401898688",
        phoneSalesCaption: "+358 40 189 8688",
        emailSalesContact: "heikki.vepsalainen@youpret.com",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Яни Кямяряйнен",
        nameJaniFi:"(фин. Jani Kämäräinen)",
        emailJani: "jani.kamarainen@youpret.com",
        emailJaniShort: "jani@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        titleJani: "Менеджер службы устных переводов",
        titleJaniInfo: "",
        nameNea: "Нэа Руотсалайнен",
        nameNeaFi: "(фин. Nea Ruotsalainen)",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "+358406403600",
        phoneNeaCaption: "+358 40 640 3600",
        titleNea: "Менеджер по обслуживанию клиентов",
        customerServiceNea: "(Служба поддержки клиентов)",
        titleNeaInfo: "",
        nameCOO: "Майя Рютконен",
        nameCOOFi: "(фин. Maya Rytkönen)",
        emailMaya: "maya.rytkonen@youpret.com",
        emailMayaShort: "maya@youpret.com",
        MayaInfo: "(On parental leave)",
        phoneMaya: "+358456688113",
        phoneMayaCaption: "+358 45 668 8113",
        titleMaya: "Операционный директор",
        titleMayaInfo: "",
        nameAbrial: "Абриэль Бертель",
        nameAbrialFi: "(фин. Abrial Bertel)",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        customerSupportCaption: "Служба поддержки клиентов (финский)",
        customerService: "+358456688113",
        customerServiceCaption: "+358 45 668 8113",
        titleAbrial: "Менеджер по развитию",
        titleAbrialInfo: "Отчётность",
        nameSuvi: "Суви Кингелин",
        nameSuviFi: "(фин. Suvi Kingelin)",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        phoneSuvi: "+358400169278",
        phoneSuviCaption: "+358 400 169 278",
        titleSuvi: "Специалист по обслуживанию клиентов",
        titleSuviInfo: "",
        nameSatu: "Сату Пирхонен",
        nameSatuFi: "(фин. Satu Pirhonen)",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneSatu: "+358406325979",
        phoneSatuCaption: "+358 406 325 979",
        titleSatu: "Менеджер по работе с клиентами",
        titleSatuInfo: "",
        nameLaura: "Лаура Косонен",
        nameLauraFi: "(фин. Laura Kosonen)",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        titleLaura: "Специалист службы устных переводов",
        titleLauraInfo: "",
        nameNeaK: "Неа Колмонен",
        nameNeaKFi: "(фин. Nea Kolmonen)",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "+358400254410",
        phoneNeaKolmonenCaption: "+358 40 025 4410",
        titleNeaKolmonen: "Менеджер по маркетингу и связям с общественностью",
        titleNeaKolmonenInfo: "",
        nameTanja: "Таня Маджугина",
        nameTanjaFi: "(фин. Tanja Madzhugina)",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 401 816 692",
        titleTanja: "Менеджер по финансам и администрированию",
        titleTanjaInfo: "",
    },
    sv: {
        phoneAbbr: "TEL ",
        emailSales: "sales@youpret.com",
        emailHello: "hello@youpret.com",
        emailOffice: "office@youpret.com",
        emailJobs: "jobs@youpret.com",
        addressTitle: "Youpret Oy",
        addressStreet: "Kauppakatu",
        addressNumber: "17 B",
        addressPostcode: "80100",
        addressCity: "Joensuu",
        addressCountry: "FINLAND",
        titleDOS: "Director of Sales",
        titleDOSInfo: "Försäljning",
        nameDOS: "",
        nameCOO: "Maya Rytkönen",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleCEO: "VD",
        titleCEOInfo: "",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Heikki Vepsäläinen",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCTO: "CTO",
        titleCTOInfo: "",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Heikki Vepsäläinen",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        nameSales: "Heikki Vepsäläinen",
        phoneSales: "+358407054377",
        phoneSalesCaption: "+358 40 705 4377",
        emailSalesContact: "heikki.vepsalainen@youpret.com",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Jani Kämäräinen",
        titleJani: "Tolkservicechef",
        titleJaniInfo: "",
        emailJani: "jani.kamarainen@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        nameNea: "Nea Ruotsalainen",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "+358406403600",
        phoneNeaCaption: "+358 40 640 3600",
        titleNea: " Kundservicechef",
        titleNeaInfo: "",
        emailMaya: "maya.rytkonen@youpret.com",
        phoneMaya: "+358400149295",
        phoneMayaCaption: "+358 400 149 295",
        titleMaya: "Operativ Chef",
        MayaInfo: "",
        nameAbrial: "Abrial Bartel",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        customerService: "+358454908250",
        customerServiceCaption: "+358 45 490 8250",
        utc: ", (UTC +2) 08:00 - 16:00",
        titleAbrial: "Programutvecklare",
        nameLaura: "Laura Kosonen",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        titleLaura: "Specialist, Tolk- och personaltjänster",
        titleLauraInfo: "",
        nameSuvi: "Suvi Kingelin",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        titleSuvi: "Kundrådgivare",
        titleSuviInfo: "",
        customerSupportCaption: "Kundservice",
        phoneAccounting: "+358 40 014 9478",
        phoneAccountingCaption: "040 014 9478",
        phoneAccounting1: "040 014 9478",
        nameSatu: "Satu Pirhonen",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneSatu: "+358406325979",
        phoneSatuCaption: "+358 406 325 979",
        titleSatu: "Kundansvarig",
        titleSatuInfo: "",
        nameNeaK: "Nea Kolmonen",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "+358400254410",
        phoneNeaKolmonenCaption: "+358 40 025 4410",
        titleNeaKolmonen: "Marknads- och kommunikationschef",
        titleNeaKolmonenInfo: "",
        nameTanja: "Tanja Madzhugina",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 401 816 692",
        titleTanja: "Chef för ekonomi och administration",
        titleTanjaInfo: "",
        nameAida: "Aida Jodeiri",
    },
    de: {
        phoneAbbr: "TEL ",
        emailSales: "sales@youpret.com",
        emailHello: "hello@youpret.com",
        emailOffice: "office@youpret.com",
        emailJobs: "jobs@youpret.com",
        addressTitle: "Youpret Oy",
        addressStreet: "Kauppakatu",
        addressNumber: "17 B",
        addressPostcode: "80100",
        addressCity: "Joensuu",
        addressCountry: "FINLAND",
        titleDOS: "Director of Sales",
        titleDOSInfo: "Verkauf",
        nameDOS: "",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleCEO: "CEO",
        titleCEOInfo: "",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Heikki Vepsäläinen",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCEO: "Geschäftsführer",
        titleCTO: "CTO",
        titleCTOInfo: "Verkauf, Verträge",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Heikki Vepsäläinen",
        nameCOO: "Maya Rytkönen",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        nameSales: "Heikki Vepsäläinen",
        phoneSales: "+358401898688",
        phoneSalesCaption: "+358 40 189 8688",
        emailSalesContact: "heikki.vepsalainen@youpret.com",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Jani Kämäräinen",
        titleJani: "Leiter der Dolmetscherdienste",
        titleJaniInfo: "",
        emailJani: "jani.kamarainen@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        nameNea: "Nea Ruotsalainen",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "+358406403600",
        phoneNeaCaption: "+358 40 640 3600",
        titleNea: "Kundendienstmanagerin",
        titleNeaInfo: "",
        emailMaya: "maya.rytkonen@youpret.com",
        MayaInfo: "(Elternzeit)",
        phoneMaya: "+358400149295",
        phoneMayaCaption: "+358 400 149 295",
        titleMaya: "Betriebsleitung",
        titleMayaInfo: "",
        nameAbrial: "Abrial Bertel",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        customerService: "+358456688113",
        customerServiceCaption: "+358 45 668 8113",
        titleAbrial: "Entwicklungsleiter",
        titleAbrialInfo: "Reporting",
        nameLaura: "Laura Kosonen",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        phoneLaura: "+358456688113",
        phoneLauraCaption: "+358 45 668 8113",
        titleLaura: "Expertin, Dolmetsch- und Personaldienstleistungen",
        titleLauraInfo: "",
        nameSuvi: "Suvi Kingelin",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        phoneSuvi: "+358400169278",
        phoneSuviCaption: "+358 40 016 9278",
        titleSuvi: "Expertin, Kundenberatung",
        titleSuviInfo: "",
        customerSupportCaption: "Kundendienst auf Englisch",
        customerServiceInSwedish: " Kundendienst auf Schwedisch",
        customerServiceSwedish: "+358454908250",
        customerServiceSwedishCaption: "+358 45 490 8250",
        nameSatu: "Satu Pirhonen",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneSatu: "+358406325979",
        phoneSatuCaption: "+358 40 632 5979",
        titleSatu: "Account-Managerin",
        titleSatuInfo: "",
        nameNeaK: "Nea Kolmonen",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "+358400254410",
        phoneNeaKolmonenCaption: "+358 40 025 4410",
        titleNeaKolmonen: "Marketing- und Kommunikationsleiterin",
        titleNeaKolmonenInfo: "",
        nameTanja: "Tanja Madzhugina",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 40 181 6692",
        titleTanja: "Finanz- und Verwaltungsleiterin",
        titleTanjaInfo: "",
        nameAida: "Aida Jodeiri",
        titleAida:"",
    },
    is: {
        phoneAbbr: "TEL ",
        emailSales: "info@youpret.is",
        emailHello: "info@youpret.is",
        emailOffice: "info@youpret.is",
        emailJobs: "info@youpret.is",
        addressTitle: "Youpret Iceland",
        addressStreet: "Laugavegur",
        addressNumber: "11",
        addressPostcode: "101",
        addressCity: "Reykjavík",
        addressCountry: "ICELAND",
        titleDOS: "Director of Sales",
        titleDOSInfo: "Sala",
        nameDOS: "",
        phoneDOS: "",
        phoneDOSCaption: "",
        titleCEO: "CEO",
        titleCEOInfo: "",
        emailCEO: "heikki.vepsalainen@youpret.com",
        emailCEOShort: "heikki@youpret.com",
        nameCEO: "Heikki Vepsäläinen",
        phoneCEO: "+358401898688",
        phoneCEOCaption: "+358 40 189 8688",
        titleCTO: "CTO",
        titleCTOInfo: "",
        emailCTO: "heikki.vepsalainen@youpret.com",
        emailCTOShort: "heikki@youpret.com",
        nameCTO: "Heikki Vepsäläinen",
        nameCOO: "Maya Rytkönen",
        phoneCTO: "+358401393250",
        phoneCTOCaption: "+358 40 139 3250",
        nameSales: "Heikki Vepsäläinen",
        phoneSales: "+358401898688",
        phoneSalesCaption: "+358 40 189 8688",
        emailSalesContact: "info@youpret.is",
        emailSalesContactShort: "heikki@youpret.com",
        nameJani: "Jani Kämäräinen",
        titleJani: "Interpreter and client manager",
        titleJaniInfo: "",
        emailJani: "jani.kamarainen@youpret.com",
        phoneJani: "+358407054377",
        phoneJaniCaption: "+358 40 705 4377",
        nameNea: "Nea Ruotsalainen",
        emailNea: "nea.ruotsalainen@youpret.com",
        emailNeaShort: "nea@youpret.com",
        phoneNea: "+358406403600",
        phoneNeaCaption: "+358 40 640 3600",
        titleNea: "Customer service manager",
        titleNeaInfo: "",
        emailMaya: "maya.rytkonen@youpret.com",
        MayaInfo: "(On parental leave)",
        phoneMaya: "+358400149295",
        phoneMayaCaption: "+358 400 149 295",
        titleMaya: "COO",
        titleMayaInfo: "",
        nameAbrial: "Abrial Bertel",
        emailAbrial: "abrial.bertel@youpret.com",
        emailAbrialShort: "abrial@youpret.com",
        customerService: "5873000",
        customerServiceCaption: "587 3000, ",
        titleAbrial: "Development manager",
        titleAbrialInfo: "Reporting",
        nameLaura: "Laura Kosonen",
        emailLaura: "laura.kosonen@youpret.com",
        emailLauraShort: "laura@youpret.com",
        phoneLaura: "+358456688113",
        phoneLauraCaption: "+358 45 668 8113",
        titleLaura: "Expert, interpreter and customer services",
        titleLauraInfo: "",
        nameSuvi: "Suvi Kingelin",
        emailSuvi: "suvi.kingelin@youpret.com",
        emailSuviShort: "suvi@youpret.com",
        phoneSuvi: "+358400169278",
        phoneSuviCaption: "+358 400 169 278",
        titleSuvi: "Customer Advisor",
        titleSuviInfo: "",
        headerEmail: "Netfang: ",
        customerSupportCaption : "Símanúmer: ",
        customerServiceInSwedish : "Notendaþjónusta á sænsku",
        customerServiceSwedish: "+358454908250",
        customerServiceSwedishCaption: "+358 45 490 8250",
        nameSatu: "Satu Pirhonen",
        emailSatu: "satu.pirhonen@youpret.com",
        emailSatuShort: "satu@youpret.com",
        phoneSatu: "+358406325979",
        phoneSatuCaption: "+358 406 325 979",
        titleSatu: "Account manager",
        titleSatuInfo: "",
        nameNeaK: "Nea Kolmonen",
        emailNeaKolmonen: "nea.kolmonen@youpret.com",
        emailNeaKolmonenShort: "",
        phoneNeaKolmonen: "+358400254410",
        phoneNeaKolmonenCaption: "+358 40 025 4410",
        titleNeaKolmonen: "Marketing and communications manager",
        titleNeaKolmonenInfo: "",
        nameTanja: "Tanja Madzhugina",
        emailTanja: "tanja.madzhugina@youpret.com",
        emailTanjaShort: "tanja@youpret.com",
        phoneTanja: "+358401816692",
        phoneTanjaCaption: "+358 401 816 692",
        titleTanja: "Financial and administration manager",
        titleTanjaInfo: "",
        nameAida: "Aida Jodeiri",
        titleAida: "Samfélagsábyrgðarverkefnastjóri",
        emailAida: "aida.jodeiri@youpret.com",
        
        applyEmail: "info@youpret.is", 
        applyPhone: "",
        applyPhoneCaption: "",
    },
    ee: {
        phoneAbbr: "TODO",
        emailSales: "TODO",
        emailHello: "TODO",
        emailOffice: "TODO",
        emailJobs: "TODO",
        addressTitle: "TODO",
        addressStreet: "TODO",
        addressNumber: "TODO",
        addressPostcode: "TODO",
        addressCity: "TODO",
        addressCountry: "TODO",
        titleDOS: "TODO",
        titleDOSInfo: "TODO",
        nameDOS: "TODO",
        phoneDOS: "TODO",
        phoneDOSCaption: "TODO",
        titleCEO: "TODO",
        titleCEOInfo: "TODO",
        emailCEO: "TODO",
        emailCEOShort: "TODO",
        nameCEO: "TODO",
        phoneCEO: "TODO",
        phoneCEOCaption: "TODO",
        titleCTO: "TODO",
        titleCTOInfo: "TODO",
        emailCTO: "TODO",
        emailCTOShort: "TODO",
        nameCTO: "TODO",
        nameCOO: "TODO",
        phoneCTO: "TODO",
        phoneCTOCaption: "TODO",
        nameSales: "TODO",
        phoneSales: "TODO",
        phoneSalesCaption: "TODO",
        emailSalesContact: "TODO",
        emailSalesContactShort: "TODO",
        nameJani: "TODO",
        titleJani: "TODO",
        titleJaniInfo: "TODO",
        emailJani: "TODO",
        phoneJani: "TODO",
        phoneJaniCaption: "TODO",
        nameNea: "TODO",
        emailNea: "TODO",
        emailNeaShort: "TODO",
        phoneNea: "TODO",
        phoneNeaCaption: "TODO",
        titleNea: "TODO",
        titleNeaInfo: "TODO",
        emailMaya: "TODO",
        MayaInfo: "TODO",
        phoneMaya: "TODO",
        phoneMayaCaption: "TODO",
        titleMaya: "TODO",
        titleMayaInfo: "TODO",
        nameAbrial: "TODO",
        emailAbrial: "TODO",
        emailAbrialShort: "TODO",
        customerService: "TODO",
        customerServiceCaption: "TODO",
        titleAbrial: "TODO",
        titleAbrialInfo: "TODO",
        nameLaura: "TODO",
        emailLaura: "TODO",
        emailLauraShort: "TODO",
        phoneLaura: "TODO",
        phoneLauraCaption: "TODO",
        titleLaura: "TODO",
        titleLauraInfo: "TODO",
        nameSuvi: "TODO",
        emailSuvi: "TODO",
        emailSuviShort: "TODO",
        phoneSuvi: "TODO",
        phoneSuviCaption: "TODO",
        titleSuvi: "TODO",
        titleSuviInfo: "TODO",
        customerSupportCaption : "TODO",
        customerServiceInSwedish : "TODO",
        customerServiceSwedish: "TODO",
        customerServiceSwedishCaption: "TODO",
        nameSatu: "TODO",
        emailSatu: "TODO",
        emailSatuShort: "TODO",
        phoneSatu: "TODO",
        phoneSatuCaption: "TODO",
        titleSatu: "TODO",
        titleSatuInfo: "TODO",
        nameNeaK: "TODO",
        emailNeaKolmonen: "TODO",
        emailNeaKolmonenShort: "TODO",
        phoneNeaKolmonen: "TODO",
        phoneNeaKolmonenCaption: "TODO",
        titleNeaKolmonen: "TODO",
        titleNeaKolmonenInfo: "TODO",
        nameTanja: "TODO",
        emailTanja: "TODO",
        emailTanjaShort: "TODO",
        phoneTanja: "TODO",
        phoneTanjaCaption: "TODO",
        titleTanja: "TODO",
        titleTanjaInfo: "TODO",
        nameAida: "TODO",
        titleAida: "TODO",
        emailAida: "TODO",
        
        applyEmail: "TODO", // todo: update to real ones
        applyPhone: "TODO",
        applyPhoneCaption: "TODO",
    },
};